import ApiService from '@/services/api.service'

const ItemCategoryService = {

    getAll() {          
        const requestData = {
            method: 'get',
            url: "/ItemCategories",
            headers: {
                
            },
            params: { 
               
            }
        }
        return ApiService.customRequest(requestData);
    },    

    add(data){
        return ApiService.post(`/ItemCategories`, data);
    },

    update(Id,data){
        return ApiService.put(`/ItemCategories/${Id}`,data);
    },

    delete(id){
        return ApiService.delete(`/ItemCategories/${id}`)
    },

    getItemCategories(parameter){       
        const requestData = {
            method: 'get',
            url: "/ItemCategories/",       
            params: {  
                SearchCriteria: parameter.SearchCriteria,
                PageSize: parameter.PageSize,
                PageNumber: parameter.PageNumber
            }
        }
        return ApiService.customRequest(requestData);
    },

    Get(Id){     
        return ApiService.get(`/ItemCategories/${Id}`);
    },
}
  
  export default ItemCategoryService;